import { useTheme } from "@reactive-resume/hooks";
import { cn } from "@reactive-resume/utils";
import { constants } from "../../../../apps/constants";
type Props = {
  size?: number;
  className?: string;
};

export const Logo = ({ size = 50, className }: Props) => {
  const { isDarkMode } = useTheme();

  let src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

  switch (isDarkMode) {
    case false:
      //src = "/logo/light.svg";
      src = `"${constants.logoUrl.mybharat}"`;
      break;
    case true:
      //src = "/logo/dark.svg";
      src = `"${constants.logoUrl.mybharat}"`;
      break;
  }

  return (
    <img
      src={src}
      width="120"
      height="50"
      alt="Reactive Resume"
      className={cn("rounded-sm", className)}
    />
  );
};
